import React from 'react';
import './footer.scss';

export function Footer() {
  const current_year = new Date().getFullYear();
  return (
    <footer className='footer'>
      <div className="container">
        <span className="text-muted">©&nbsp; 2018-{current_year}&nbsp;·&nbsp;
          <span className="pattaya">НАОЛИ</span>
          &nbsp;·&nbsp; ИП Завилохина Н.Г.&nbsp;·&nbsp; ОГРНИП 318784700109634&nbsp;·&nbsp; ИНН 784301055265&nbsp;·&nbsp; зарегистрировано 06.04.2018
        </span>
      </div>
    </footer>
  );
}
